module.exports = __webpack_public_path__ + "r-v3/img/ico_user.41105ff3.svg";